import { EngineVisibilityEnum } from './engine-visibility.enum';

export class EnginePositionModel {
    public right: number;
    public bottom: number;

    constructor(
        public left: number,
        public top: number,
        public width: number,
        public height: number,
        public visibility: EngineVisibilityEnum
    ) {}
}
